/*
 * @description:
 * @author: Jason Wong
 * @since: 2024-07-11 10:32:25
 */
const predefinedRoleTemplate = {
  catUser: ["normalUser-widget"],
  schoolMgr: ["schoolMgr-widget"],
};

const anonymousWidgetName = "anonymous-join-widget";

function getWidgetTemplate(roles) {
  console.log("!!-@@ roles", roles);
  let roleList = [];
  if (roles) {
    const type = Object.prototype.toString.call(roles);
    if (type == "[object String]") roleList = roles.split(",");
    else if (type == "[object Array]") roleList = roles;
  }

  var res = [];
  if (roleList.length > 0) {
    roleList.$$each((r) => {
      if (r in predefinedRoleTemplate) {
        predefinedRoleTemplate[r].$$each((prer) => {
          if (!res.$$any((ar) => ar == prer)) {
            res.push(prer);
          }
        });
      }
    });
  }
  if (res.length == 0) {
    res.push(anonymousWidgetName);
  }
  console.log("!!-@@ res", res);
  return res;
}

export { getWidgetTemplate };
